import { useBrowserStorage } from '@optools/hooks/useBrowserStorage';
import { ReactNode } from 'react';

import { Sidebar } from './components/sidebar';

export function Dashboard({ children }: { children: ReactNode }) {
  const [open, setOpen] = useBrowserStorage('localStorage', 'sidebarOpen', false);

  return (
    <div className="grid h-screen w-full grid-cols-[auto_1fr]">
      <Sidebar open={open} onToggleOpen={() => setOpen((current) => !current)} />
      <main className="relative flex-1 gap-4 overflow-auto">{children}</main>
    </div>
  );
}
